import React, {Component} from 'react';
import { connect }          from 'react-redux';
import './index.scss';

//components
import PhoneValidation from '../../../login/phone_validation';
import {generateVereficationCode} from "../../../../redux/actions";

//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath, } from "../../../../app/functions";


class PurchaseApprovalPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            selected_radio: this.props.selected,
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
        this.props.generateVereficationCode({phone: this.props.phone, user_id: this.props.data.userId});

        if(this.props.isAcquired){
            this.setState({step: 2});
        }
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleSubmit = () =>{
        this.props.action();
        this.animateOut();
    };

    render() {

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper Purchase-approval-popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className="popup_content">
                        <button className="x_close_icon"
                                onClick={() => this.animateOut()}
                                aria-label="סגור"><img src={getMediaPath(desktop_exit)} alt='/'/>
                        </button>


                        <div className='msg'>
                            <span className='final-price'>{this.props.translation["purchase_validation_popup_amount_to_pay"] +" " + this.props.price}</span>
                            <span className='congrats'>{this.props.translation['purchase_popup_text']}</span>
                        </div>
                        <PhoneValidation isEditFlow={false} phone={this.props.phone} action={this.props.action} btnText={this.props.translation["purchase_popup_btn"]} is_first_login={false}/>
                        {/*<button className='purchase-btn' onClick={this.handleSubmit}>{this.props.translation['purchase_popup_btn']}</button>*/}
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        translation: store.config.Translations,
        benefit: store.data.BenefitPage,
        userDate: store.config.UserData,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        generateVereficationCode: (payload) => dispatch(generateVereficationCode(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PurchaseApprovalPopup);